import React from "react";

import "./ChatWidgetMainView.css";

import { PostMessageType, MediaType, AllowedFileType, AllowedImageType } from "../../constants";
import PostMessageContext from "../../context/PostMessageContext";
import WebService from "../../service/webService";

class ChatWidgetMainViewChatField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: "",
            file: null,
            fileType: null,
            uploading: false,
            initialScrollHeight: 0,
            noOfRows: 0
        };
        this.WebService = new WebService();
        this.textArea = React.createRef();
    }

    handleChange = (e) => {
        const message = e.target.value;
        this.context.IframePostMessage({
            Message: PostMessageType.TypingHint,
            Data: message
        });
        this.setState({ message });
    };

    handleInputKeyDown = (e) => {
        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            this.sendMessage();
        }
    };

    handleFileChange = (e) => {
        let file = e.target.files[0];
        let fileType = "";
        const uploadedFileType = file.type.split("/")[1];
        if (file && AllowedFileType.includes(uploadedFileType)) {
            if (AllowedImageType.includes(uploadedFileType)) {
                fileType = MediaType.IMAGE;
                let reader = new FileReader();
                reader.onload = (e) => {
                    let imagePreview = e.target.result;
                    this.props.onFileChange({ file, imagePreview, fileType });
                };
                reader.readAsDataURL(file);
            } else {
                fileType = MediaType.DOCUMENT;
                this.props.onFileChange({ file, fileType });
            }
            this.setState({ file, fileType });
        } else {
            fileType = MediaType.UNSUPPORTED;
            // this.props.onFileChange({ file, fileType });
            this.setState({ file: null, fileType: null });
        }
        if (e && e.target && e.target.value) {
            e.target.value = null;
        }
        this.textArea.current.focus();
    };

    clearSelectedFile = () => {
        this.setState({ file: null, fileType: null });
    };

    sendMessage = async (e) => {
        e && e.preventDefault();
        const { message, uploading } = this.state;
        const { visitorData } = this.context;

        if (uploading) {
            return;
        }
        if (this.state.file) {
            try {
                this.setState({ uploading: true });
                this.props.onFileChange({ imageUploading: true });
                let responseData = await this.WebService.uploadMedia(
                    this.state.file,
                    visitorData.chatId,
                    visitorData.visitorId
                );
                this.context.IframePostMessage({
                    Message: PostMessageType.SendMessage,
                    Data: { responseData, file: this.state.file, message: message || "" }
                });
                this.setState({ message: "" });
            } catch (e) {
                console.log("err", e);
            } finally {
                this.setState({ file: null, fileType: null, uploading: false });
                this.props.onFileChange({
                    file: null,
                    fileType: null,
                    imagePreview: null,
                    imageUploading: false
                });
            }
        } else if (!!message.trim().length) {
            this.context.IframePostMessage({
                Message: PostMessageType.SendMessage,
                Data: message
            });
            this.setState({ message: "" });
            if (!this.state.file && this.props.handleImageClearClick) {
                this.props.handleImageClearClick();
            }
        }
    };

    canSendMessage = () => {
        const { message, file } = this.state;
        return (message && !!message.trim().length) || file;
    };

    static ClipIcon = ({ color }) => {
        return (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path id="Path 13617" d="M17.0485 8.44543L9.46117 15.6013C8.53168 16.4779 7.27096 16.9704 5.95643 16.9704C4.64191 16.9704 3.38122 16.4779 2.4517 15.6013C1.52219 14.7247 1 13.5357 1 12.2959C1 11.0562 1.52219 9.86715 2.4517 8.99052L10.0391 1.83463C10.6588 1.2502 11.4992 0.921875 12.3756 0.921875C13.2519 0.921875 14.0924 1.2502 14.7121 1.83463C15.3317 2.41906 15.6799 3.21172 15.6799 4.03823C15.6799 4.86474 15.3317 5.65741 14.7121 6.24183L7.11642 13.3976C6.80658 13.6899 6.38636 13.8541 5.94818 13.8541C5.51 13.8541 5.08978 13.6899 4.77993 13.3976C4.4701 13.1055 4.29603 12.7092 4.29603 12.2959C4.29603 11.8827 4.4701 11.4863 4.77993 11.1941L11.7893 4.59108" stroke="black" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        );
    };

    static SendButton = ({ color }) => {
        return (
            <svg width="16" height="13" viewBox="0 0 16 13" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill={color}
                    id="Path 13618"
                    d="M2.54369 6.37905L0.755726 10.849C0.509632 11.4642 1.03816 12.0838 1.67643 11.9057C2.93593 11.5545 4.9078 10.9288 7.26377 9.91911C11.3938 8.14908 14.3439 6.37905 14.3439 6.37905M2.54369 6.37905L0.755713 1.90912C0.509613 1.29391 1.03819 0.674329 1.67643 0.852359C2.93589 1.2036 4.90785 1.8293 7.26377 2.83899C11.3938 4.60902 14.3439 6.37905 14.3439 6.37905M2.54369 6.37905L14.3439 6.37905"
                    stroke="white"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    };
    checkForNewRow = () => {
        const currentScrollHeight = this.textArea.current.scrollHeight;
        const { initialScrollHeight, noOfRows } = this.state;

        if (currentScrollHeight > initialScrollHeight) {
            this.setState({
                initialScrollHeight: currentScrollHeight,
                noOfRows: noOfRows + 1
            });
        }
    };
    render() {
        const { widgetSettings } = this.context;
        return (
            <div className="chat-field">
                <form onSubmit={this.sendMessage}>
                    <textarea
                        ref={this.textArea}
                        value={this.state.message}
                        onChange={this.handleChange}
                        onKeyDown={this.handleInputKeyDown}
                        onInput={this.checkForNewRow}
                        type="text"
                        maxLength="1000"
                        placeholder="Write Message ..."
                    ></textarea>
                    <div className="actions">
                        <div className="action-btn add">
                            <span>
                                <input type="file" onChange={this.handleFileChange} />
                            </span>
                            <ChatWidgetMainViewChatField.ClipIcon
                                color={widgetSettings.Appearance.ActionButtonColor}
                            />
                        </div>
                        <button
                            className={`action-btn action-btn-send send ${this.canSendMessage() ? "allowed" : ""
                                }`}
                            type="submit"
                            style={{
                                background: widgetSettings.Appearance.TitleBarColor,
                                width: "28px",
                                height: "28px",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                transform: "translateY(-5px)"
                            }}
                        >
                            <ChatWidgetMainViewChatField.SendButton
                                color={widgetSettings.Appearance.TitleBarColor}
                            />
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

ChatWidgetMainViewChatField.contextType = PostMessageContext;

export default ChatWidgetMainViewChatField;
